import React, { useEffect, useMemo, useRef, useState } from "react";

export default function WebsiteAutocomplete({
  websites,
  activeWebsiteId,
  onSelectWebsite,
  placeholder = "Search website by name or URL..."
}) {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const selectedWebsite = useMemo(
    () => websites.find((w) => String(w.id) === String(activeWebsiteId)) || null,
    [websites, activeWebsiteId]
  );

  useEffect(() => {
    if (selectedWebsite) {
      setQuery(selectedWebsite.name);
    } else {
      setQuery("");
    }
  }, [selectedWebsite]);

  useEffect(() => {
    const closeOnOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", closeOnOutside);
    return () => document.removeEventListener("mousedown", closeOnOutside);
  }, []);

  const filtered = useMemo(() => {
    const normalized = query.trim().toLowerCase();
    if (!normalized) return websites;
    return websites.filter((website) => {
      const name = String(website.name || "").toLowerCase();
      const url = String(website.url || "").toLowerCase();
      return name.includes(normalized) || url.includes(normalized);
    });
  }, [query, websites]);

  return (
    <div className="website-autocomplete" ref={rootRef}>
      <input
        value={query}
        placeholder={placeholder}
        onFocus={() => setOpen(true)}
        onChange={(event) => {
          setQuery(event.target.value);
          setOpen(true);
        }}
      />

      {open ? (
        <div className="website-autocomplete-panel">
          {filtered.map((website) => (
            <button
              key={website.id}
              type="button"
              className={`website-option ${String(website.id) === String(activeWebsiteId) ? "active" : ""}`}
              onClick={() => {
                onSelectWebsite(website.id);
                setOpen(false);
              }}
            >
              <strong>{website.name}</strong>
              <span>{website.url}</span>
            </button>
          ))}
          {!filtered.length ? <p className="website-option-empty">No website matches this search.</p> : null}
        </div>
      ) : null}
    </div>
  );
}
